import React, { useState } from 'react'
import { Col, Input as Ip, Select } from 'antd'
import * as UI from 'konsys-ui'
import _ from 'lodash'
import { Query } from 'react-apollo'
import { useQuery } from '@apollo/react-hooks'
import { detailMode } from '../constants'
import { DRIVER_LIST, GET_TRAILER_LIST, GET_TRUCK_BRAND_LIST } from '../../../constants/graphql/query'
import { checkInt } from '../../../utils/util-services'
import { EjectTrailerModal } from './extension-components'
import { Uploader } from '../../../components/common'

/*
date.type is type of component
0: InputWithLabel
1: input
2: Text (P)
3: Dropdown (Select)
4: Radio
5: TextArea
6: Select
7: P with Label
*/

const truckTypeSelector = (value) => {
  switch (value) {
    case 'PADOONGRICH':
      return 'ผดุงฤทธิ์'
    case 'JOINTCAR':
      return 'รถร่วมในเครือ'
    case 'OUTJOINTCAR':
      return 'รถร่วมนอก'
    default: return 'ไม่ระบุ'
  }
}

const { TextArea } = Ip

const CreateMode = ({
  data, disabled, onChangeHandler, selectedData, mutationVariables,
}) => {
  const [dropdownText, setText] = useState('เลือก')
  const [driverName, setDriverName] = useState()
  const [trailerPlateSearch, setTrailerPlateSearch] = useState()
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span}>
          <UI.InputWithLabel
            {...data.props}
            width='100%'
            input={{
              padding: '5px',
              margin: '0 0 2px',
              onChange: e => onChangeHandler(data.id, data.valueType === 'int' ? parseInt(e.target.value, 10) : e.target.value),
              onKeyDown: (e) => {
                if (data.id === 'truckWeight' && !checkInt(e)) {
                  e.preventDefault()
                }
              },
              type: data.id === 'truckWeight' ? 'number' : 'text',
              step: data.id === 'truckWeight' ? '1' : undefined,
              min: '0',
            }}
          />
        </Col>
      )
    case 1:
      return <UI.Input {...data.props} />
    case 2:
      return <UI.P {...data.props}>{data.label}</UI.P>
    case 3:
      return <Col
        span={data.span}
        style={{ alignSelf: 'flex-end', margin: '0 0 16px 0' }}
      >
        <UI.Div display='flex' flexDirection='column'>
          <UI.P margin='0 0 16px'>{data.label}</UI.P>
          <UI.Select
            dropdown
            data={selectedData[data.id]}
            buttonProps={{
              disabled,
              ...data.props.buttonProps, // data props override buttonProps because it is at the bottom, so this might help
              text: dropdownText,
            }}
            onChange={(e) => {
              onChangeHandler(data.id, e.value)
              setText(e.text)
            }}
          />
        </UI.Div>
      </Col>
    case 4:
      return (
        <Col
          span={data.span}
          style={{ alignSelf: 'flex-end', margin: '0 0 16px 0' }}
        >
          <UI.RadioGroup {...data.props} list={data.list} defaultCheckedValue={data.list[0].value} vertical={data.isVertical} onChange={e => onChangeHandler(data.id, e.target.value)} />
        </Col>
      )
    case 5:
      return <Col
        span={data.span}
        style={{ alignSelf: 'flex-end' }}
      >
        <UI.Div display='flex' flexDirection='column'>
          <UI.P margin='0 0 16px'>{data.label}</UI.P>
          <TextArea {...data.props} onChange={e => onChangeHandler(data.id, e.target.value)}/>
        </UI.Div>
      </Col>
    case 6:
      return <Col
        span={data.span}
        style={{}}
      >
        <UI.Div display='flex' flexDirection='column' margin='0'>
          <UI.P margin='0 0 16px'>{data.label}</UI.P>
          <Select
            disabled={data.disabled}
            showSearch
            defaultValue={data.id === 'fleet' ? mutationVariables.fleet : data.defaultValue}
            optionFilterProp="children"
            onChange={(e) => {
              const targetObj = _.find(selectedData[data.id], r => r.value === e)
              if (data.id === 'driverId') onChangeHandler(data.id, targetObj.value, targetObj.fleet)
              else onChangeHandler(data.id, targetObj.value)
            }}
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
          {
            selectedData[data.id].map((v, i) => <Select.Option key={i} value={v.value}>{v.text}</Select.Option>)
          }
          </Select>
        </UI.Div>
      </Col>
    case 7: // only truckOwnerType
    {
      const selectedTruckType = _.find(selectedData[data.id], o => o.ownerId === mutationVariables.truckOwnerId)
      return <Col
          span={data.span}
        >
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 0 20px'>{data.label}</UI.P>
            <UI.P margin='0 0 12px'>{_.isUndefined(selectedTruckType) ? 'ยังไม่ได้เลือกเจ้าของรถ' : truckTypeSelector(selectedTruckType.type)}</UI.P>
          </UI.Div>
        </Col>
    }
    case 8: // only fleet
    {
      const fleetCode = mutationVariables.fleet
      return <Col
          span={data.span}
        >
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 0 20px'>{data.label}</UI.P>
            <UI.P margin='0 0 12px'>{_.isUndefined(fleetCode) ? 'ยังไม่ได้เลือกคนขับรถ' : fleetCode}</UI.P>
          </UI.Div>
        </Col>
    }
    case 9: // only driver
      return <Col
        span={data.span}
        style={{}}
      >
        <UI.Div display='flex' flexDirection='column' margin='0'>
          <UI.P margin='0 0 16px'>{data.label}</UI.P>
          <Query
            query={DRIVER_LIST}
            variables={
              {
                fullname: driverName,
                status: 'NEW',
              }
            }
          >{({
            data: driverData, error, loading: driverLoading, refetch: driverRefetch,
          }) => {
            if (driverLoading && _.isEmpty(driverData)) return <UI.Loading center='true' />
            if (error) return <UI.P>เกิดข้อผิดพลาด</UI.P>
            return (
            <Select
              loading={driverLoading}
              disabled={data.disabled}
              showSearch
              defaultValue={data.id === 'fleet' ? mutationVariables.fleet : data.defaultValue}
              optionFilterProp="children"
              onSearch={(e) => {
                setDriverName(e)
                driverRefetch()
              }}
              onChange={(e) => {
                const targetObj = _.find(driverData.DriverList.lists, r => r.id === e)
                if (data.id === 'driverId') onChangeHandler(data.id, targetObj.id, targetObj.fleetCode)
                else onChangeHandler(data.id, targetObj.value)
              }}
            >
            {
              driverData.DriverList.lists.map((v, i) => <Select.Option key={i} value={v.id}>{v.fullname}</Select.Option>)
            }
            </Select>)
          }}
          </Query>
        </UI.Div>
      </Col>
    case 10: // only trailer
      return <Col
      span={data.span}
      style={{}}
    >
      <UI.Div display='flex' flexDirection='column'>
        <UI.P margin='0 0 16px'>{data.label}</UI.P>
        <Query
          query={GET_TRAILER_LIST}
          variables={{
            trailerPlate: trailerPlateSearch,
            isAvailable: true,
          }}
        >{({
          data: trailerData, error, loading: trailerLoading, refetch: trailerRefetch,
        }) => {
          if (trailerLoading && _.isEmpty(trailerData)) return <UI.Loading center='true' />
          if (error) return <UI.P>เกิดข้อผิดพลาด</UI.P>
          return (
          <Select
            loading={trailerLoading}
            disabled={data.disabled}
            showSearch
            optionFilterProp="children"
            onSearch={(e) => {
              setTrailerPlateSearch(e)
            }}
            onChange={(e) => {
              const selected = _.find(trailerData.TrailerList.lists, r => r.trailerPlate === e)
              onChangeHandler(data.id, selected.id, selected.type)
            }}
          >
          {
            trailerData.TrailerList.lists.map((v, i) => <Select.Option key={i} value={v.trailerPlate}>{v.trailerPlate}</Select.Option>)
          }
          </Select>)
        }}
        </Query>
      </UI.Div>
    </Col>
    case 11:
    {
      const { trailerType } = mutationVariables
      return <Col
        span={data.span}
      >
        <UI.Div display='flex' flexDirection='column'>
          <UI.P margin='0 0 16px'>{data.label}</UI.P>
          <UI.P margin='5px 0'>{_.isUndefined(trailerType) ? 'ยังไม่ได้เลือกหางพ่วง' : _.isNull(trailerType) ? 'ไม่มีข้อมูลชนิดของหางพ่วงนี้' : trailerType.nameTh }</UI.P>
        </UI.Div>
      </Col>
    }
    case 12:
    {
      const {
        data: truckBrandData, loading: truckBrandLoading,
      } = useQuery(GET_TRUCK_BRAND_LIST)
      return <Col
        span={data.span}
      >
        <UI.Div display='flex' flexDirection='column' margin='8px 0 0'>
          <UI.P margin='0 0 16px'>{data.label}</UI.P>
          <Select
            style={{ width: '100%' }}
            loading={truckBrandLoading}
            disabled={data.disabled}
            optionFilterProp="children"
            onChange={(e) => {
              onChangeHandler(data.id, e)
            }}
          >
          {
            truckBrandData?.TruckBrandList?.lists.map((v, i) => <Select.Option key={i} value={v.id}>{v.name}</Select.Option>)
          }
          </Select>
        </UI.Div>
      </Col>
    }
    case 13: return null
    default:
      return <p>No type</p>
  }
}

const EditMode = ({
  data, disabled, onChangeHandler, initialData, selectedData, mutationVariables, disableButton, setDisableButton,
}) => {
  const [value, setValue] = useState(initialData[data.id])
  const [driverName, setDriverName] = useState()
  const [trailerPlateSearch, setTrailerPlateSearch] = useState()
  const [modal, setModal] = useState(false)

  switch (data.type) {
    case 0:
      return (
        <Col span={data.span}>
          <UI.InputWithLabel
            {...data.props}
            width='100%'
            input={{
              padding: '5px',
              margin: '0 0 2px',
              onChange: e => onChangeHandler(data.id, data.valueType === 'int' ? parseInt(e.target.value, 10) : e.target.value),
              onKeyDown: (e) => {
                if (data.id === 'truckWeight' && !checkInt(e)) {
                  e.preventDefault()
                }
              },
              type: data.id === 'truckWeight' ? 'number' : 'text',
              step: data.id === 'truckWeight' ? '1' : undefined,
              min: '0',
              disabled: data.id === 'plateNumber' ? disabled || !_.includes(window.perms, 'UPDATE_LICENESE_TRUCK') : disabled,
              defaultValue: initialData[data.id],
            }}
          />
        </Col>
      )
    case 1:
      return <UI.Input disabled={disabled} {...data.props} />
    case 2:
      return <UI.P disabled={disabled} {...data.props}>{data.label}</UI.P>
    case 3: // **********************************************************************************************************************
      return <Col
        span={data.span}
        style={{ alignSelf: 'flex-end', margin: '0 0 16px 0' }}
      >
        <UI.Div display='flex' flexDirection='column'>
          <UI.P margin='0 0 16px'>{data.label}</UI.P>
          <UI.Select
            dropdown
            disabled={disabled}
            data={_.isUndefined(selectedData[data.id]) ? [{ value: 1, text: '1' }] : selectedData[data.id]}

            buttonProps={{
              ...data.props.buttonProps,
              text: value,
              disabled,
            }}

            onChange={(e) => {
              onChangeHandler(data.id, e.value)
              setValue(e.value)
            }}
          />
        </UI.Div>
      </Col>
    case 4:
      return (
        <Col
          span={data.span}
          style={{ alignSelf: 'flex-end', margin: '0 0 16px 0' }}
        >
          <UI.RadioGroup
            disabled={disabled}
            {...data.props}
            list={data.list}
            defaultCheckedValue={data.list[0].value}
            vertical={data.isVertical}
            onChange={e => onChangeHandler(data.id, e.target.value)}
          />
        </Col>
      )
    case 5:
      return <Col
        span={data.span}
        style={{ alignSelf: 'flex-end' }}
      >
        <UI.Div display='flex' flexDirection='column'>
          <UI.P margin='0 0 16px'>{data.label}</UI.P>
          <TextArea disabled={disabled} {...data.props} defaultValue={initialData[data.id]} onChange={e => onChangeHandler(data.id, e.target.value)}/>
        </UI.Div>
      </Col>
    case 6:
      return <Col
        span={data.span}
        style={{ alignSelf: 'flex-end', margin: '0 0 16px 0' }}
      >
        <UI.Div display='flex' flexDirection='column' margin='0'>
          <UI.P margin='0 0 16px'>{data.label}</UI.P>
          <Select
            disabled={disabled || data.disabled}
            showSearch
            defaultValue={initialData[data.id]}
            optionFilterProp="children"
            onChange={(e) => {
              const targetObj = _.find(selectedData[data.id], r => r.value === e)
              if (data.id === 'driverId') onChangeHandler(data.id, targetObj.value, targetObj.fleet)
              else onChangeHandler(data.id, targetObj.value)
            }}
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
          {
            selectedData[data.id].map((v, i) => <Select.Option key={i} value={v.value}>{v.text}</Select.Option>)
          }
          </Select>
        </UI.Div>
      </Col>
    case 7: // only truckOwnerType
    {
      const selectedTruckType = mutationVariables.truckOwnerType
        ? _.find(initialData[data.id], o => o.ownerId === mutationVariables.truckOwnerId)
        : { type: initialData.truckOwnerType }
      return <Col
          span={data.span}
        >
          <UI.Div display='flex' flexDirection='column' margin='0 0 8px'>
            <UI.P margin='0 0 20px'>{data.label}</UI.P>
            <UI.P margin='0 0 12px'>{_.isUndefined(selectedTruckType) ? 'ยังไม่ได้เลือกเจ้าของรถ' : truckTypeSelector(selectedTruckType.type)}</UI.P>
          </UI.Div>
        </Col>
    }
    case 8: // only fleet
    {
      const fleetCode = _.isUndefined(mutationVariables.fleet) ? initialData.driver.fleetCode : mutationVariables.fleet
      return <Col
          span={data.span}
        >
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 0 20px'>{data.label}</UI.P>
            <UI.P margin='0 0 12px'>{_.isUndefined(fleetCode) ? 'ยังไม่ได้เลือกคนขับรถ' : fleetCode}</UI.P>
          </UI.Div>
        </Col>
    }
    case 9: // only Driver
      // setDriverName(initialData[data.id])
      return <Col
        span={data.span}
        style={{ alignSelf: 'flex-end', margin: '0 0 16px 0' }}
      >
        <UI.Div display='flex' flexDirection='column' margin='0'>
          <UI.P margin='0 0 16px'>{data.label}</UI.P>
          <Query
            query={DRIVER_LIST}
            variables={
              {
                fullname: driverName,
                status: 'NEW',
              }
            }
          >{({
            data: driverData, error, loading: driverLoading, refetch: driverRefetch,
          }) => {
            if (driverLoading && _.isEmpty(driverData)) return <UI.Loading center='true' />
            if (error) return <UI.P>เกิดข้อผิดพลาด</UI.P>
            return (
            <Select
              loading={driverLoading}
              disabled={disabled}
              showSearch
              defaultValue={initialData[data.id]}
              optionFilterProp="children"
              onSearch={(e) => {
                setDriverName(e)
                driverRefetch()
              }}
              onChange={(e) => {
                const targetObj = _.find(driverData.DriverList.lists, r => r.id === e)
                if (data.id === 'driverId') onChangeHandler(data.id, targetObj.id, targetObj.fleetCode)
                else onChangeHandler(data.id, targetObj.value)
              }}
            >
            {
              driverData.DriverList.lists.map((v, i) => <Select.Option key={i} value={v.id}>{v.fullname}</Select.Option>)
            }
            </Select>)
          }}
          </Query>
        </UI.Div>
      </Col>
    case 10: // only trailer
      return <Col
      span={data.span}
      style={{ alignSelf: 'flex-end', margin: '0 0 16px 0' }}
    >
      <UI.Div display='flex' flexDirection='column' margin='8px 0 0 0'>
        <UI.P margin='0 0 16px'>{data.label}</UI.P>
        <UI.Div display='flex' flexDirection='row' margin='0 0 0 0'>
        <Query
          query={GET_TRAILER_LIST}
          variables={{
            trailerPlate: trailerPlateSearch,
            isAvailable: true,
          }}
        >{({
          data: trailerData, error, loading: trailerLoading, refetch: trailerRefetch,
        }) => {
          if (trailerLoading && _.isEmpty(trailerData)) return <UI.Loading center='true' />
          if (error) return <UI.P>เกิดข้อผิดพลาด</UI.P>
          if (!_.isNull(initialData.trailer) && !_.includes(trailerData.TrailerList.lists, initialData.trailer)) trailerData.TrailerList.lists.push(initialData.trailer)
          return (
          <UI.Div display='flex' flexDirection='row' margin='0 0 0 0' width='68%'>
          <Select
            style={{ width: '404px' }}
            loading={trailerLoading}
            disabled={disabled || (!_.isNull(initialData.trailer) && !disableButton)}
            showSearch
            defaultValue={_.isNull(initialData.trailer) ? '' : initialData.trailer.trailerPlate}
            optionFilterProp="children"
            onSearch={(e) => {
              setTrailerPlateSearch(e)
            }}
            onChange={(e) => {
              const selected = _.find(trailerData.TrailerList.lists, r => r.trailerPlate === e)
              onChangeHandler(data.id, selected.id, selected.type)
            }}
          >
          {
            trailerData.TrailerList.lists.map((v, i) => <Select.Option key={i} value={v.trailerPlate}>{v.trailerPlate}</Select.Option>)
          }
          </Select>
          </UI.Div>)
        }}
        </Query>
        <UI.Button
        disabled={disabled || _.isNull(initialData.trailer) || disableButton}
        margin='0 0 0 8px'
        small
        text={'ถอดหางพ่วง'}
        onClick={() => {
          setModal(true)
        }}
        />
        </UI.Div>
      </UI.Div>
      <EjectTrailerModal modal={modal} setModal={setModal} truckId={initialData.id} setDisableButton={setDisableButton} plateNumber={initialData.plateNumber}/>
    </Col>
    case 11:
    {
      const trailerType = !_.isUndefined(mutationVariables.trailerType)
        ? mutationVariables.trailerType
        : !_.isNull(initialData.trailer) && !_.isNull(initialData.trailer.type)
          ? initialData.trailer.type.nameTh
          : !_.isNull(initialData.trailer)
            ? null
            : 'ยังไม่ได้เลือกหางพ่วง'
      return <Col
        span={data.span}
      >
        <UI.Div display='flex' flexDirection='column' margin='8px 0 0'>
          <UI.P margin='0 0 16px'>{data.label}</UI.P>
          <UI.P margin='5px 0'>{_.isUndefined(trailerType) ? 'ยังไม่ได้เลือกหางพ่วง' : _.isNull(trailerType) ? 'ไม่มีข้อมูลชนิดของหางพ่วงนี้' : trailerType }</UI.P>
        </UI.Div>
       </Col>
    }
    case 12:
    {
      const {
        data: truckBrandData, loading: truckBrandLoading,
      } = useQuery(GET_TRUCK_BRAND_LIST)
      return <Col
        span={data.span}
      >
        <UI.Div display='flex' flexDirection='column' margin='8px 0 0'>
          <UI.P margin='0 0 16px'>{data.label}</UI.P>
          <Select
            style={{ width: '100%' }}
            loading={truckBrandLoading}
            disabled={disabled}
            defaultValue={_.isNull(initialData.branId) ? '' : initialData.TruckBrand?.id}
            optionFilterProp="children"
            onChange={(e) => {
              onChangeHandler(data.id, e)
            }}
          >
          {
            truckBrandData?.TruckBrandList?.lists.map((v, i) => <Select.Option key={i} value={v.id}>{v.name}</Select.Option>)
          }
          </Select>
        </UI.Div>
      </Col>
    }
    case 13: {
      if (mutationVariables && mutationVariables.driverId !== initialData.driver.id) {
        return (
          <Col
            span={data.span}
          >
            <Uploader
              buttonText='อัพโหลดรูป'
              onChange={e => onChangeHandler('truckFiles', e)}
              data={(mutationVariables.truckFiles || []).map(file => (file.url ? { name: _.flatten(_.takeRight(_.split(file.url, '/'))), uid: file.url, url: file.url } : file)) || []}
              isMultiple={true}
              accept='image/*'
              disabled={disabled}
            />
          </Col>
        )
      }
      return null
    }
    default:
      return <p>No type</p>
  }
}

export default ({
  data, mode, onChangeHandler, initialData, disabled, selectedData, mutationVariables, disableButton, setDisableButton,
}) => {
  switch (mode) {
    case detailMode.ADD:
      return (
        <CreateMode
          data={data}
          disabled={disabled}
          selectedData={selectedData}
          onChangeHandler={(id, value, optional) => onChangeHandler(id, value, optional)}
          mutationVariables={mutationVariables}
        />
      )
    case detailMode.EDIT:
      return (
        <EditMode
          data={data}
          mode={mode}
          selectedData={selectedData}
          initialData={initialData}
          onChangeHandler={(id, value, optional) => onChangeHandler(id, value, optional)}
          mutationVariables={mutationVariables}
          disableButton={disableButton}
          setDisableButton={setDisableButton}
        />
      )
    case detailMode.VIEW:
      return (
        <EditMode
          data={data}
          mode={mode}
          disabled={true}
          initialData={initialData}
          selectedData={selectedData}
          onChangeHandler={(id, value) => onChangeHandler(id, value)}
          mutationVariables={mutationVariables}
          disableButton={disableButton}
          setDisableButton={setDisableButton}
        />
      )
    default:
      return <p>no mode</p>
  }
}
